import { render } from "./JuicesList.vue?vue&type=template&id=2f6ae804"
import script from "./JuicesList.vue?vue&type=script&lang=js"
export * from "./JuicesList.vue?vue&type=script&lang=js"

import "./JuicesList.vue?vue&type=style&index=0&id=2f6ae804&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__